import { Component, OnInit } from '@angular/core';
import {LoaderService} from '../../../services/common/loader-service/loader.service';
import {UserPrivilegeService} from '../../../services/common/user-privilege/user-privilege.service';
import {AttributesApiService} from '../../../services/api/users/attributes/attributes-api.service';
import {LicenseFeaturesService} from '../../../services/common/license-features/license-features.service';
import {
  RegistrationRoutingApiService
} from '../../../services/api/settings/routing/registration-routing/registration-routing-api.service';

@Component({
  selector: 'registration-routing-setting',
  templateUrl: './registration-routing-setting.component.html',
  styleUrls: ['./registration-routing-setting.component.scss']
})
export class RegistrationRoutingSettingComponent implements OnInit {

  registrationSettings: any = {};
  dictionaryProperties: any = [];
  isRegistrationEnabled: boolean;
  isUnauthorized: boolean;

  constructor(private userPrivilege: UserPrivilegeService,
              private licenseFeaturesService: LicenseFeaturesService,
              private attributesApiService: AttributesApiService,
              private registrationRoutingApiService: RegistrationRoutingApiService,
              private loadService: LoaderService) { }

  ngOnInit(): void {
    this.isUnauthorized = this.userPrivilege.isAuthorized();
    this.initialization();
  }

  initialization(): void {
    this.loadService.showMainContainer();
    this.licenseFeaturesService.isFeatureSupported(
      'numberOfUsersRouteRegistrations').subscribe(isFeatureSupported => {
      this.isRegistrationEnabled = isFeatureSupported;

      if (isFeatureSupported) {
        this.registrationRoutingApiService.getRegistrationRoutingSettings().subscribe((conf) => {
          this.registrationSettings = conf;
          this.attributesApiService.getAttributes().then(attr => {
            this.loadService.hideMainContainer();
            this.dictionaryProperties = attr;
          });
        });
      } else {
        this.loadService.hideMainContainer();
      }
    });
  }

  submit(): void {
    this.registrationRoutingApiService.editRegistrationRoutingSettings(this.registrationSettings).subscribe((conf) => {
      this.registrationSettings = conf;
    });
  }

}
